<template>
  <div v-show="show">
    <div
      class="relative z-[100]"
      aria-labelledby="slide-over-title"
      role="dialog"
      aria-modal="true"
    >
      <!-- Background backdrop, show/hide based on slide-over state. -->
      <div class="fixed inset-0"></div>

      <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
          <div
            class="pointer-events-none fixed inset-y-0 left-0 flex max-w-full pr-10 sm:pr-16"
          >
            <!--
          Slide-over panel, show/hide based on slide-over state.

          Entering: "transform transition ease-in-out duration-500 sm:duration-700"
            From: "translate-x-full"
            To: "translate-x-0"
          Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
            From: "translate-x-0"
            To: "translate-x-full"
        -->
            <transition
              enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
              enter-class="-translate-x-full"
              enter-to-class="translate-x-0"
              leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
              leave-class="translate-x-0"
              leave-to-class="-translate-x-full"
            >
              <div v-show="show" class="pointer-events-auto w-screen max-w-md">
                <div
                  class="flex h-full flex-col overflow-y-hidden bg-white shadow-xl"
                >
                  <div class="px-5 py-3 bg-gray-100">
                    <div class="flex items-center justify-between">
                      <h2
                        class="text-sm font-semibold leading-6 text-gray-900"
                        id="slide-over-title"
                      >
                        Werteraum speichern
                      </h2>
                      <div class="ml-3 flex h-7 items-center">
                        <button
                          @click="cancel"
                          type="button"
                          class="relative rounded-md bg-transparent text-gray-400 focus:ring-2 hover:text-markencode-blue focus:ring-markencode-blue"
                        >
                          <span class="absolute -inset-2.5"></span>
                          <span class="sr-only">Close panel</span>
                          <svg
                            class="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- alert: start -->

                  <div
                    v-show="showAlert"
                    class="rounded-md bg-green-50 px-5 py-2"
                  >
                    <div class="flex">
                      <div class="flex-shrink-0">
                        <svg
                          class="h-5 w-5 text-green-400"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </div>
                      <div class="ml-3">
                        <p class="text-sm font-medium text-green-800">
                          Werteraum gespeichert
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- alert: end -->

                  <div
                    class="mt-2 px-5 py-3 flex flex-wrap items-center gap-x-2 gap-y-2"
                  >
                    <div
                      v-for="(word, idx) in selectedWords"
                      :key="idx"
                      class="inline-flex items-center justify-between gap-x-1 rounded-md border border-gray-400 px-2 py-1 text-xs"
                    >
                      <span>{{ word.word }}</span>

                      <zone-color-icons
                        :colors="word.zone_colors"
                        :mini="true"
                      ></zone-color-icons>
                    </div>

                    <!-- <p
                      class="text-sm text-gray-500"
                      v-for="(word, idx) in selectedWords"
                      :key="idx"
                    >
                      {{ word.word }}
                    </p> -->
                  </div>

                  <div class="mt-2 px-5 py-3">
                    <input
                      type="text"
                      v-model="form.name"
                      autofocus
                      class="form-input bg-white border-gray-200 border-solid focus:border-markencode-blue focus:ring-transparent px-3 py-1.5 sm:mr-2 sm:py-2 rounded-md block sm:inline w-full sm:w-64 shadow-none sm:text-sm focus:ring-markencode-blue mb-3 placeholder:text-gray-400"
                      placeholder="Werteraumname"
                    />

                    <button
                      type="button"
                      @click="submit"
                      :disabled="disabled"
                      class="inline-flex w-full justify-center rounded-md bg-brandpreneurship-dark-gray px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black sm:ml-3 sm:w-auto"
                      :class="disabled ? 'opacity-60' : ''"
                    >
                      Speichern
                    </button>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- value space create: end -->
</template>

<script>
import ZoneColorIcons from '@/Pages/Markencode/Dictionary/Shared/ZoneColorIcons.vue';

export default {
  components: {
    ZoneColorIcons,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    selectedWords: Array,
  },

  data() {
    return {
      form: {
        name: '',
      },
      showAlert: false,
    };
  },

  methods: {
    submit() {
      // console.log(this.selectedWords);

      if (this.disabled) {
        return;
      }

      window.axios
        .post(this.route('markencode.dictionary.value-space.store'), {
          words: this.selectedWords,
          name: this.form.name,
        })

        .then((response) => {
          this.form.name = '';
          this.showAlert = true;

          setTimeout(() => {
            this.cancel();
          }, 1500);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    cancel() {
      this.showAlert = false;
      this.$emit('cancelled');
    },
  },

  computed: {
    disabled() {
      return this.form.name.length < 2;
    },
  },
};
</script>
